import { Button, Group, Modal, Stack, Text } from '@mantine/core'
import { DeviceAdvertisementsForHost } from '../models/DeviceAdvertisementsForHost'
import { COLORS } from '../utils/constants'

interface CancelAutoRenewModalProps {
  ad: DeviceAdvertisementsForHost | null
  isOpen: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
  isCancelling: boolean
}

export function CancelAutoRenewModal({
  ad,
  isOpen,
  onClose,
  onConfirm,
  isCancelling,
}: CancelAutoRenewModalProps) {
  if (!ad) return null

  const endDateLocal = new Date(ad.endDateLocal ?? '')
  const formattedEndDate = endDateLocal?.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title='Cancel Auto-Renewal?'
      centered
      size='lg'
      styles={{
        title: {
          fontSize: '1.5rem',
          fontWeight: 500,
        },
      }}
    >
      <Stack gap='xl' py='md'>
        <Stack gap='xs'>
          <Text size='lg'>
            Would you like to stop renewing this advertisement at{' '}
            {ad.locationName} - {ad.deviceName}?
          </Text>
          <Text size='sm' c='dimmed' mt='xs'>
            Your current advertisement will remain active until{' '}
            {formattedEndDate}.
          </Text>
        </Stack>
        <Group gap='md' justify='space-between'>
          <Button
            variant='outline'
            onClick={onClose}
            disabled={isCancelling}
            size='md'
            styles={{
              label: {
                fontSize: '0.9rem',
              },
            }}
          >
            No, Keep Running Ad
          </Button>
          <Button
            color={COLORS.HiddenGemzRed}
            onClick={onConfirm}
            loading={isCancelling}
            loaderProps={{ type: 'dots' }}
            size='md'
            styles={{
              label: {
                fontSize: '0.9rem',
              },
            }}
          >
            Yes, Cancel Auto-Renewal
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
